import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    usageBox: {
        backgroundColor: '#f3f4f6',
        borderRadius: 8,
        padding: 16,
        marginBottom: 20,
    },
    usageRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 10,
    },
    usageLabel: {
        fontWeight: 700,
    },
    usageValue: {
        fontWeight: 600,
    },
    progressRoot: {
        height: 6,
        borderRadius: 9999,
        backgroundColor: '#e5e7eb',
    },
    progressBar: {
        borderRadius: 9999,
        backgroundColor: (props) => props.barColor,
    },
    usageSubRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: (props) => (props.hasResetLabel ? 'space-between' : 'flex-end'),
        alignItems: 'center',
        marginTop: 10,
    },
    remaining: {
        fontSize: 13,
        fontWeight: 600,
        color: theme.palette.success.main,
    },
    resetLabel: {
        fontSize: 13,
        color: theme.palette.text.secondary,
    },
}));
